import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AddMovieHeader from "../components/AddMovieHeader";

export default function TermsAgreement({ onAgree, onCancel }) {
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()

  const handleCancel = () => {
    if (typeof onCancel === "function") onCancel();
    navigate("/movie-box");
  };

  const handleSaveDraft = () => {
    console.log("Save draft clicked");
  };

  const handleContinue = () => {
    // console.log(checked,typeof onAgree)
    if (!checked) return;
    if (typeof onAgree === "function") onAgree();
    navigate("/movie-box/add-movie/movie-details?"+searchParams?.toString());
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
     
      <AddMovieHeader
        onContinue={handleContinue}
        onCancel={handleCancel}
        onSaveDraft={handleSaveDraft}
        continueDisabled={!checked}
        showProgress={false}
      />

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-2xl bg-white flex flex-col p-6 rounded-md shadow-sm">
          <h2 className="text-xl font-semibold mb-8 text-center">
            Agree to Terms
          </h2>

          <div className="border border-gray-200 rounded-md p-4 h-60 overflow-y-auto text-sm text-gray-700 mb-6 bg-blue-50">
            {Array.from({ length: 12 }).map((_, i) => (
              <p key={i} className="mb-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                euismod, nunc in suscipit tincidunt, sapien justo pretium orci,
                nec commodo urna mi a erat. Donec id nibh nec elit consequat
                feugiat. Integer efficitur metus nec lorem pulvinar, at
                ullamcorper sapien porttitor.
              </p>
            ))}
          </div>

          <label className="flex items-center space-x-3 mb-8">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              className="w-4 h-4 rounded border-gray-300 focus:ring-primary"
            />
            <span className="text-sm text-gray-700">
              I have read and agree to the Terms of Service and Content
              Guidelines
            </span>
          </label>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleCancel}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleContinue}
              disabled={!checked}
              className={`px-6 py-2 rounded-md text-white ${
                checked
                  ? "bg-primary hover:bg-primary-dark"
                  : "bg-blue-200 cursor-not-allowed"
              }`}
            >
              Continue
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
